import logger from 'loglevel';
export const vendorIds = {
    schibstedMediaNorway: '6006e4ea53ea8d11de684749',
    schibstedMediaSweden: '6006e3abdd926426f307a209',
};
const AnalyticsPurposeId = '65250d55efa12506fb78666d';
export const checkVendorPurposeMapping = (a) => {
    if (a.vendorId === vendorIds.schibstedMediaNorway) {
        if (a.categories?.some((category) => category._id == AnalyticsPurposeId)) {
            // If the vendor has the category Analytics, we need analytics consent
            return true;
        }
    }
    else if (a.vendorId === vendorIds.schibstedMediaSweden) {
        // Swedish vendor means we always need analytics consent
        return true;
    }
    return false;
};
/**
 * Checks if TCF is configured to request analytics consent
 * Can be refactored to just return true and deprecated/removed after January 2025
 * @returns {Promise<Boolean>} if subscribe('CMP:analytics') can be safely used
 */
export async function canSubscribeToAnalyticsConsent() {
    if (!window.__tcfapi) {
        logger.error('CMP canSubscribeToAnalyticsConsent: window.__tcfapi is not available');
        return false;
    }
    return new Promise((resolve) => {
        window.__tcfapi('getVendorPurposeMapping', 2, (vendorPurposeMapping, success) => {
            if (!success) {
                logger.error('CMP canSubscribeToAnalyticsConsent: Failed to get vendor purpose mapping');
                resolve(false);
            }
            resolve(vendorPurposeMapping.some(checkVendorPurposeMapping));
        });
    });
}
